export enum AssetType {
	ATTRIBUTE = 'ATTRIBUTE',
	MODEL = 'MODEL'
}